import { inject as service } from '@ember/service';
import Route from 'mewe/routes/route';
import Session from 'mewe/shared/session';

export default Route.extend({
  router: service(),
  analytics: service(),

  redirect() {
    this._super();

    if (Session.hasAuthCookie()) {
      this.router.transitionTo('app.myworld');
    } else {
      this.router.transitionTo('register');
    }
  },
});
